import React,{useState} from 'react';
import {motion,AnimatePresence} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiExternalLink,FiX}=FiIcons;

const Experts=()=> {
  const [selectedExpert,setSelectedExpert]=useState(null);

  const experts=[
    {
      name: 'Nadine Rau',
      specialty: 'Yin Yoga – Achtsamkeit & Präsenz',
      description: 'Nadine führt dich mit einer ruhigen, klaren Haltung durch die Yin Yoga Einheiten.\nIhre Stunden laden dich ein, den Körper zu öffnen, Spannungen loszulassen und in einen Zustand tiefer Ruhe zu finden.',
      image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1759853827963-portrait_nadine.jpg'
    },
    {
      name: 'Marcella Toby',
      specialty: 'Klangbegleitung – Wärme & Feingefühl',
      description: 'Marcella arbeitet mit Klängen, die das Nervensystem beruhigen und den Körper in Entspannung tragen.\nIhre Klänge schaffen eine Atmosphäre, in der du dich sicher, gehalten und in dir selbst ruhend fühlen kannst.',
      website: 'https://www.klangzeit-kassel.de/',
      logo: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1759854788801-Logo%20Marcella.png',
      image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1759853588521-portrait_marcella.jpg'
    }
  ];

  return (
    <>
      <section id="experts" className="py-16 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <motion.div initial={{opacity: 0,y: 30}} whileInView={{opacity: 1,y: 0}} transition={{duration: 0.8}} viewport={{once: true}} className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-serif text-stone-800 mb-6" style={{fontFamily: 'Libre Baskerville,serif'}}>Deine Begleiterinnen</h2>
            <p className="text-lg text-stone-600 max-w-3xl mx-auto" style={{fontFamily: 'Lato,sans-serif'}}>
              Wir begleiten dich achtsam durch deine Entspannungsreise.<br />
              Jede von uns bringt ihre eigene Stärke mit – gemeinsam halten wir den Raum für Ruhe und Leichtigkeit.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-12 mb-16">
            {experts.map((expert,index)=> (
              <motion.div key={expert.name} initial={{opacity: 0,y: 30}} whileInView={{opacity: 1,y: 0}} transition={{duration: 0.8,delay: index * 0.3}} viewport={{once: true}} whileHover={{scale: 1.02,y: -5}} className="bg-[#F9F5F0] p-8 rounded-2xl shadow-lg border border-[#CBB8A9]">
                <div className="text-center mb-6">
                  <div className="w-40 h-40 mx-auto mb-6 overflow-hidden rounded-full border-4 border-white shadow-lg cursor-pointer hover:scale-105 transition-transform duration-200" onClick={()=> setSelectedExpert(expert)}>
                    <img src={expert.image} alt={`Porträt ${expert.name}`} className="w-full h-full object-cover" />
                  </div>
                  <h3 className="text-2xl font-serif text-stone-800 mb-2" style={{fontFamily: 'Libre Baskerville,serif'}}>{expert.name}</h3>
                  <p className="text-lg font-semibold mb-3" style={{fontFamily: 'Lato,sans-serif',color: '#b45309'}}>{expert.specialty}</p>

                  {expert.website && (
                    <a href={expert.website} target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-sm text-stone-600 hover:text-[#314C40] transition-colors" style={{fontFamily: 'Lato,sans-serif'}}>
                      <img src={expert.logo} alt="Klangzeit Kassel Logo" className="w-6 h-6 mr-2" />
                      <SafeIcon icon={FiExternalLink} className="w-4 h-4 mr-1" />
                      klangzeit-kassel.de
                    </a>
                  )}
                </div>

                <p className="text-stone-700 leading-relaxed text-center whitespace-pre-line" style={{fontFamily: 'Lato,sans-serif'}}>
                  {expert.description}
                </p>
              </motion.div>
            ))}
          </div>

          <motion.div initial={{opacity: 0,y: 30}} whileInView={{opacity: 1,y: 0}} transition={{duration: 0.8}} viewport={{once: true}} className="p-8 rounded-2xl shadow-lg border max-w-4xl mx-auto" style={{backgroundColor: '#F9F5F0',borderColor: '#CBB8A9'}}>
            <p className="text-stone-800 leading-relaxed text-center" style={{fontFamily: 'Lato,sans-serif'}}>
              <span className="block font-semibold mb-3 text-lg" style={{fontFamily: 'Libre Baskerville,serif',color: '#314C40'}}>Maike, Kursteilnehmerin:</span>
              <span className="italic text-base" style={{color: '#2C2C2C'}}>„Die beiden Leiterinnen sind sehr warmherzig, super sympathisch und auch sehr kompetent. Jede Übung wurde einfühlsam erklärt, mit individueller Unterstützung – so fühlt man sich rundum gut aufgehoben.“</span>
            </p>
          </motion.div>
        </div>
      </section>

      <AnimatePresence>
        {selectedExpert && (
          <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4" onClick={()=> setSelectedExpert(null)}>
            <motion.div initial={{scale: 0.8,opacity: 0}} animate={{scale: 1,opacity: 1}} exit={{scale: 0.8,opacity: 0}} className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden" onClick={(event)=> event.stopPropagation()}>
              <button onClick={()=> setSelectedExpert(null)} className="absolute top-4 right-4 z-10 w-10 h-10 bg-white/90 rounded-full flex items-center justify-center shadow-lg">
                <SafeIcon icon={FiX} className="w-6 h-6 text-stone-800" />
              </button>
              <img src={selectedExpert.image} alt={`Porträt ${selectedExpert.name}`} className="w-full h-auto object-cover" />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6 text-white">
                <h3 className="text-2xl font-serif mb-2" style={{fontFamily: 'Libre Baskerville,serif'}}>{selectedExpert.name}</h3>
                <p className="text-lg font-semibold mb-2" style={{fontFamily: 'Lato,sans-serif',color: '#b45309'}}>{selectedExpert.specialty}</p>
                <p className="text-stone-200 leading-relaxed whitespace-pre-line" style={{fontFamily: 'Lato,sans-serif'}}>{selectedExpert.description}</p>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Experts;